/**
 *  ah yes, the joy of math in JS
 *  1) parseFloat from possible string to number (or number to same number)
 *  2) get 2 decimals
 *  3) toFixed returns a string (wtf?) so turn it back into a number
 */
export function parseFloatAndFixTo2Digits(number: string | number) {
  return parseFloat(parseFloat(number as string).toFixed(2));
}
